import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
// Import flag images
import flagEn from './assets/flags/us.svg';
import flagNl from './assets/flags/nl.svg';
import flagDe from './assets/flags/de.svg';
import flagFr from './assets/flags/fr.svg';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate(); // Initialize navigate
  const [selectedLanguage, setSelectedLanguage] = useState('en'); // Default to 'en'

  useEffect(() => {
    // Get saved language from cookies or default to 'en'
    const savedLanguage = Cookies.get('i18next')?.split('-')[0] || 'en'; // Take only the first part (e.g., 'en' from 'en-US')

    // Set the selected language and update i18n
    setSelectedLanguage(savedLanguage);
    i18n.changeLanguage(savedLanguage); // Ensure the i18n instance reflects the saved language

    // Navigate to the corresponding language route if not on the default
    if (savedLanguage !== 'en') {
      navigate(`/${savedLanguage}`);
    }
  }, [i18n, navigate]);

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    setSelectedLanguage(language);
    Cookies.set('i18next', language); // Save language in a cookie

    // Redirect to the appropriate language route

    navigate(`/${language}`); // Navigate to /en, /nl, /de, or /fr

    setIsOpen(false);
  };

  return (
    <div
      className="language-selector"
      style={{ position: 'absolute', top: 40, right: 10 }}>
      <div className="selected-language" onClick={() => setIsOpen(!isOpen)}>
        {selectedLanguage === 'en' ? (
          <>
            <img
              src={flagEn}
              alt="English Flag"
              style={{ width: 20, height: 20, marginRight: 5 }}
            />
            en
          </>
        ) : selectedLanguage === 'nl' ? (
          <>
            <img
              src={flagNl}
              alt="Dutch Flag"
              style={{ width: 20, height: 20, marginRight: 5 }}
            />
            nl
          </>
        ) : selectedLanguage === 'de' ? (
          <>
            <img
              src={flagDe}
              alt="German Flag"
              style={{ width: 20, height: 20, marginRight: 5 }}
            />
            de
          </>
        ) : (
          <>
            <img
              src={flagFr}
              alt="French Flag"
              style={{ width: 20, height: 20, marginRight: 5 }}
            />
            fr
          </>
        )}
      </div>
      {isOpen && (
        <ul className="language-options">
          <li onClick={() => changeLanguage('en')}>
            <img
              src={flagEn}
              alt="English Flag"
              style={{ width: 20, height: 20, marginRight: 8 }}
            />
            en
          </li>
          <li onClick={() => changeLanguage('nl')}>
            <img
              src={flagNl}
              alt="Dutch Flag"
              style={{ width: 20, height: 20, marginRight: 8 }}
            />
            nl
          </li>
          <li onClick={() => changeLanguage('de')}>
            <img
              src={flagDe}
              alt="German Flag"
              style={{ width: 20, height: 20, marginRight: 8 }}
            />
            de
          </li>
          <li onClick={() => changeLanguage('fr')}>
            <img
              src={flagFr}
              alt="French Flag"
              style={{ width: 20, height: 20, marginRight: 8 }}
            />
            fr
          </li>
        </ul>
      )}
    </div>
  );
};

export default LanguageSelector;
